import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const nowSecure = defineConnector({
  identifier: "nowSecure",
  name: "NowSecure",
  tagLine: "Mobile application security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.nowsecure.com"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up NowSecure",
      items: [
        {
          kind: "markdown",
          content:
            "In NowSecure Platform, open your profile, select **Tokens**, and choose **Generate Token**. Name the token and copy it below. It inherits the generating account’s permissions. See [creating an API bearer token](https://support.nowsecure.com/hc/en-us/articles/7499657262093-Creating-a-NowSecure-Platform-API-Bearer-Token).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.nowsecure.com",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use NowSecure’s production Platform API host, https://api.nowsecure.com. The web console at https://app.nowsecure.com is used to create tokens, not as the API base URL. NowSecure’s current API documentation identifies the primary API host after deprecating the former Hub 2 host.",
        },
        {
          kind: "input",
          label: "NowSecure Platform API bearer token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "In the NowSecure Platform, select the profile icon, choose Tokens, select Generate Token, enter a token name, and generate the token. Copy and securely store the token; it is linked to the generating account.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.nowsecure.com").trim().replace(/\/+$/, "") +
        "/my/organization",
      ...{ method: "GET" },
    }),
  },
});
